import React, {useEffect, useMemo} from "react";
import {Formik, Form, Field} from "formik";
import * as Yup from "yup";
import {AEAutoComplete, AEInput} from "../../../../../_metronic/_partials/controls";
import {localField, languages} from "../../../../../_emywork/helpers/UIHelper";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {actionTypes as countriesActionTypes} from "../../../Countries/_redux/slice";
import {fetchEntities as getCountries} from "../../../Countries/_redux/actions";

export function EditForm({ entity, btnRef, saveEntity, validationErrors = []}) {

  const dispatch = useDispatch();
  const {countries, meta} = useSelector(state=> {
    const {entities, meta} = state.countries[countriesActionTypes.LocationFilterList]
    return {
      countries:entities,
      meta
    }
  },shallowEqual)

  useEffect(()=>{
    dispatch(getCountries(meta, countriesActionTypes.LocationFilterList))
  }, [dispatch, meta])


  const EditSchema = useMemo(()=>{
    return Yup.object().shape({
      country_id: Yup.number().required() ,
      name_ar: Yup.string().required() ,
      name_en: Yup.string().required() ,
      name_fr: Yup.string().required() ,
      name_es: Yup.string().required() ,
    })
  }
  ,[])



  return (
    <>
      <Formik
        enableReinitialize
        initialValues={entity}
        initialErrors={validationErrors}
        validationSchema={EditSchema}
        onSubmit={(values) => {
          // console.log(values)
          saveEntity(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (

          <Form className="form form-label-right">
            <div className="form-group row">
              <div className={"col-lg-12"}>
                <Field
                  name={`country_id`}
                  component={AEAutoComplete}
                  label={`COUNTRY`}
                  options={countries}
                  getOptionLabel={o=> o[localField('name')]}
                  useId
                />
              </div>
            </div>
            {
              languages.map(l=>(
                <div key={l.lang} className="form-group row">
                  <div className={"col-lg-12"}>
                    <Field
                      name={`name_${l.lang}`}
                      component={AEInput}
                      label={`LANG.${l.lang.toUpperCase()}`}
                      // customFeedbackLabel={formatMessage({id:'FORM.MULTI_LANG.NAME'},{lang:formatMessage({id:`LANG.${l.lang.toUpperCase()}`})})}
                      dir={l.rtl?'rtl':'ltr'}
                    />
                  </div>
                </div>
              ))
            }
            <button
                type="submit"
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={handleSubmit}
            />
        </Form>
        )}
      </Formik>
    </>
  );
}
